import { forwardRef } from 'react';
import '../assets/css/ContactUs.css';
import { AppConstant } from '../constant/AppConstant';

const ContactUs = forwardRef<HTMLElement, {}>((props, ref) => {
    return (
        <section className="all-main-section" ref={ref}>
            <div className="all-main-section-overlay"></div>
            <div className="all-main-section-content-wrapper">
                <h2 className="all-main-title" style={{ textAlign: "center" }}>
                    Let’s <span>Connect</span>
                </h2>
                {/* <div className="all-main-section-left"> */}
                    <div className="contact-item">
                        <i className="fa-solid fa-envelope contact-icon"></i>
                        <a href={AppConstant.MAIL_TO_EMAIL}>{AppConstant.CONTACT_EMAIL}</a>
                    </div>
                    <div className="contact-item">
                        <i className="fa-solid fa-phone contact-icon"></i>
                        <a href={AppConstant.CALL_PHONE_NUMBER}>{AppConstant.CONTACT_PHONE_NUMBER}</a>
                    </div>
                    {/* <div className="contact-item">
                        <i className="fa-solid fa-location-dot contact-icon"></i>
                        <p>
                           {AppConstant.CONTACT_ADDRESS}
                        </p>
                    </div> */}
                {/* </div> */}

                {/* <div className="all-main-section-right">
                    <iframe
                        title="Our Location"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6016.712098337824!2d70.77672773483143!3d22.268031289818506!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3959cbe38f147e51%3A0x3966b65ea1a1758e!2sBalaji%20Hall!5e0!3m2!1sen!2sin!4v1748328457769!5m2!1sen!2sin"
                        width="100%"
                        height="400"
                        style={{ border: 0 }}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                </div> */}
            </div>
        </section>
    );
});

export default ContactUs;
